import cx from "classnames";
import React from "react";
import * as s from "./LoadingSkeleton.module.css";
const LoadingSkeleton = ({ as: As = "div", className, children, style }) => /* @__PURE__ */ React.createElement(As, {
  className: cx(s.shimmering, className),
  style
}, children);
var LoadingSkeleton_default = LoadingSkeleton;
export {
  LoadingSkeleton_default as default
};
